import { SEVERITY_RANK, STATUS_SEVERITY, StatusSeverityKey } from '../constants/StatusSeverity';
import { AppConnectionStatuses } from '../constants/appConnectionStatuses';
import { WarningIcon } from 'foundations-assets/icons/components/WarningIcon';
import { UpgradeIcon } from 'foundations-assets/icons/components/UpgradeIcon';
import { SuccessIcon } from 'foundations-assets/icons/components/SuccessIcon';
export const STATUS_DATE_DEFAULT_VALUE = 0;
export const STATUS_SEVERITY_RANK_DEFAULT_VALUE = 0;
export const getStatusDate = status => {
  var _status$metadata, _status$metadata2;
  return (status === null || status === void 0 || (_status$metadata = status.metadata) === null || _status$metadata === void 0 ? void 0 : _status$metadata.updatedAt) || (status === null || status === void 0 || (_status$metadata2 = status.metadata) === null || _status$metadata2 === void 0 ? void 0 : _status$metadata2.createdAt) || STATUS_DATE_DEFAULT_VALUE;
};
export const getStatusSeverity = severityKey => {
  const statusSeverityKey = severityKey && severityKey in STATUS_SEVERITY ? severityKey : StatusSeverityKey.DEFAULT;
  return STATUS_SEVERITY[statusSeverityKey];
};
export const getStatusSeverityRank = status => {
  var _status$metadata3;
  const severity = status === null || status === void 0 || (_status$metadata3 = status.metadata) === null || _status$metadata3 === void 0 ? void 0 : _status$metadata3.severity;
  return SEVERITY_RANK[severity] || STATUS_SEVERITY_RANK_DEFAULT_VALUE;
};
export const validateStatus = statusObj => {
  if (!statusObj) return false;
  const {
    userId,
    externalAccountId
  } = statusObj;
  const isUserIdValid = userId === undefined || userId > 0;
  const isExternalAccountIdValid = externalAccountId === undefined || !!externalAccountId;
  return isUserIdValid && isExternalAccountIdValid;
};
export const getSortedStatusesBySeverityRankAndDate = statusList => {
  return (statusList || []).filter(validateStatus).sort((s1, s2) => {
    return getStatusSeverityRank(s2) - getStatusSeverityRank(s1) || getStatusDate(s2) - getStatusDate(s1);
  });
};
export const getMaxStatusSeverityRank = statusList => {
  const sorted = getSortedStatusesBySeverityRankAndDate(statusList);
  return sorted.length ? getStatusSeverityRank(sorted[0]) : STATUS_SEVERITY_RANK_DEFAULT_VALUE;
};
export const getStatusIcon = statusType => {
  switch (statusType) {
    case AppConnectionStatuses.CONNECTION_LOST:
    case AppConnectionStatuses.DISCONNECTED:
      return {
        Icon: WarningIcon,
        color: 'icon-alert-default',
        backgroundColor: 'fill-alert-subtle',
        borderColor: 'fill-accent-red-subtle'
      };
    case AppConnectionStatuses.NEEDS_REAUTHORIZATION:
    case AppConnectionStatuses.SYNC_ERROR:
    case AppConnectionStatuses.NO_STATUS_AVAILABLE:
    case AppConnectionStatuses.SUNSET:
    case AppConnectionStatuses.UPCOMING_SUNSET:
      return {
        Icon: WarningIcon,
        color: 'fill-caution-pressed',
        backgroundColor: 'fill-caution-subtle',
        borderColor: 'fill-accent-yellow-subtle'
      };
    case AppConnectionStatuses.NEW_FEATURES_AVAILABLE:
    case AppConnectionStatuses.UPDATE_AVAILABLE:
    case AppConnectionStatuses.UPGRADE_AVAILABLE:
      return {
        Icon: UpgradeIcon,
        color: 'fill-accent-blue-default',
        backgroundColor: 'fill-info-subtle',
        borderColor: 'fill-accent-blue-subtle'
      };
    case AppConnectionStatuses.OK:
      return {
        Icon: SuccessIcon,
        color: 'fill-accent-green-default',
        backgroundColor: 'fill-accent-green-subtle',
        borderColor: 'fill-accent-green-subtle'
      };
    default:
      return {
        Icon: WarningIcon,
        color: 'fill-caution-pressed',
        backgroundColor: 'fill-caution-subtle',
        borderColor: 'fill-accent-yellow-subtle'
      };
  }
};